<template>
  <div class='ui-common'>
    <el-form ref='changeForm' :rules="rules" :model="changeForm" status-icon style="margin: 100px auto">
      <el-form-item label="旧密码" prop="oldPwd" class="is-required">
        <el-input type="password" v-model="changeForm.oldPwd" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd" class="is-required">
        <el-input type="password" v-model="changeForm.newPwd" auto-complete="off"></el-input>
      </el-form-item>
      <p id="ruleText"> {{ ruleText }}</p>
      <el-form-item label="重复新密码" prop="repeatPwd" class="is-required">
        <el-input type="password" v-model="changeForm.repeatPwd" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-row>
        <div style="margin-top: 10px; text-align:center">
          <el-button class='cancel-btn' type="primary" style="margin-right:10px" @click="handleCancel('changeForm')">重置</el-button>
          <el-button class='action-btn' type="primary" @click="handleSave('changeForm')">提交</el-button>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { resetPassword } from '@/views/webpc/UserMgmt/login/apis'
export default {
  name: 'pwdedit',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.changeForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      userId: undefined,
      userUuid: undefined,
      userPwdFlag: false,
      ruleText: '密码长度至少 6 位，必须且只包含数字和字母',
      changeForm: {
        oldPwd: undefined,
        newPwd: undefined,
        repeatPwd: undefined
      },
      rules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符' },
          { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!%*#?&]{6,}$/, message: '必须且只包含数字和字母' }
        ],
        repeatPwd: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validatePass }
        ]
      }
    }
  },
  methods: {
    handleSave (changeForm) {
      this.$refs[changeForm].validate((valid) => {
        if (valid) {
          let data = new FormData()
          data.append('oldpassword', this.changeForm.oldPwd)
          data.append('newpassword', this.changeForm.newPwd)
          resetPassword(data)
            .then(result => {
              this.isBtnLoading = false
              if (result) {
                this.$confirm('密码修改成功, 请重新登录！', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  type: 'success'
                }).then(() => {
                  this.$router.push('/login')
                })
              }
            })
        }
      })
    },
    handleCancel (changeForm) {
      this.$refs[changeForm].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.ui-common {
  text-align: center;
  width: 100%;
  background: #fff;
  height: 100%;
  padding: 30px;
  box-sizing: border-box;
  .el-form {
    width: 600px;
  }
}
// #ruleText {
//   margin-top: 0px;
//   margin-bottom: 10px;
//   color: #0078f4;
//   font-size: 0.8em;
// }
</style>



// WEBPACK FOOTER //
// src/views/webpc/UserMgmt/login/pwdedit.vue